import React,{useState,useEffect} from 'react';
import Sidebar from "./Sidebar.js";
import { Link } from "react-router-dom";
import { Doughnut, Line } from "react-chartjs-2";
import { useSelector, useDispatch } from "react-redux";
import { getAdminProducts } from "../../actions/productAction";
import { getAllOrders } from "../../actions/orderAction.js";
import { getAllUsers } from "../../actions/userAction.js";
import Loader from "../Loader";
import MetaData from '../../components/MetaData.js';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Title,
  Legend
);
const Dashboard = () => {

	const dispatch = useDispatch();

	const { loading, products } = useSelector((state) => state.products);

	const { orders } = useSelector((state) => state.allOrders);

	const { users } = useSelector((state) => state.allUsers);

	let outOfStock = 0;

	products &&
    products.forEach((item) => {
      if (item.Stock === 0) {
        outOfStock += 1;
      }
    });

    useEffect(() => {
		dispatch(getAdminProducts());
		dispatch(getAllOrders());
		dispatch(getAllUsers());
	}, [dispatch]);

    let totalAmount = 0;
	orders &&
	    orders.forEach((item) => {
	    totalAmount += item.totalPrice;
	});

	const lineState = {
	    labels: ["Initial Amount", "Amount Earned"],
	    datasets: [
	      {
	        label: "TOTAL AMOUNT",
	        backgroundColor: ["tomato"],
	        hoverBackgroundColor: ["rgb(197, 72, 49)"],
	        data: [0, 4000],
	      },
	    ],
	};

  	const doughnutState = {
	    labels: ["Out of Stock", "InStock"],
	    datasets: [
	      {
	        backgroundColor: ["#00A6B4", "#6800B4"],
	        hoverBackgroundColor: ["#4B5000", "#35014F"],
	        data: [outOfStock, products.length - outOfStock],
	      },
	    ],
	};

	const [currencySymbol, setCurrencySymbol] = useState("£");
  const [countryCode, setCountryCode] = useState("GB");
  const [isLoading, setIsLoading] = useState(false);

  // Country-to-Currency mapping with exchange rates
  // const countryToCurrency = {
  //   PK: { symbol: "₨", rate: 380 },
  //   US: { symbol: "$", rate: 1.2 },
  //   FR: { symbol: "€", rate: 1.15 },
  //   IN: { symbol: "₹", rate: 100 },
  //   GB: { symbol: "£", rate: 1 },
  // };

  const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

    const fetchExchangeRates = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error("Failed to fetch exchange rates");
        const data = await response.json();

        setCountryToCurrency((prev) => {
          const updatedCurrencies = { ...prev };

          Object.keys(updatedCurrencies).forEach((country) => {
            const currencyCode = updatedCurrencies[country].currencyCode;
            const rate = data.rates[currencyCode];
            if (rate) {
              updatedCurrencies[country].rate = rate;
            }
          });

          return updatedCurrencies;
        });
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    };

    // Fetch user's country using their IP address
    const fetchUserCountry = async () => {
    try {
      const response = await fetch("https://get.geojs.io/v1/ip/country.json");
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      return data.country || "GB";
    } catch (error) {
      console.error("Error fetching user country:", error);
      return "GB"; // Default to GB on failure
    }
  };


    const loadCurrencyDetails = async () => {
    setIsLoading(true);
    await fetchExchangeRates();
    const userCountry = await fetchUserCountry();
    setCountryCode(userCountry);
    // Use updated rates
  setCountryToCurrency((prev) => {
    const currencyInfo = prev[userCountry] || prev["GB"]; // Default to GBP if country not found
    setCurrencySymbol(currencyInfo.symbol || "£");
    return prev;
  });
    setIsLoading(false);
  };

  useEffect(() => {
    loadCurrencyDetails();
  }, []);
	
	return (
		<>
		{loading ? (
        <Loader />
      ) : (
      	<>
			<div className="dashboard-panel">
			<div className="container">
				<MetaData title="Dashboard - Admin Panel" />
				<div className="row">
					<Sidebar />	
					<div className="col-lg-9 col-md-8">
						<div className="dashboardContainer">
					        <h3>Dashboard</h3>

					        <div className="dashboardSummary">
					          <div className="dashboardSummaryBox2">
					          	<Link to="/admin/dashboard">
					              <p><b>Total Amount</b></p>
					              <span>{currencySymbol} {totalAmount}</span>
					            </Link>
					            <Link to="/admin/products">
					              <p><b>Courses</b></p>
					              <span>{products && products.length}</span>
					            </Link>
					            <Link to="/admin/orders">
					              <p><b>Orders</b></p>
					              <span>{orders && orders.length}</span>
					            </Link>
					            <Link to="/admin/users">
					              <p><b>Users</b></p>
					              <span>{users && users.length}</span>
					            </Link>
					          </div>
					        </div>

					        <div className="row pt-4">
					        	<div className="col-md-6 col-sm-12">
						        <div className="lineChart">
						          <Line data={lineState} />
						        </div>
						      </div>
						      <div className="col-md-6 col-sm-12">
						        <div className="doughnutChart">
						          <Doughnut data={doughnutState} />
						        </div>
						      </div>
					        </div>
					    </div>
					</div>
				</div>
			</div>
			</div>
			</>
		)}
		</>
	)
}

export default Dashboard